import { useEffect } from "react";

// COMPONENTS //
import Weapon from "../../components/Weapon";
import WakeButton from "../../components/WakeButton";
import LayeredPixiImage from "../../components/LayeredPixiImage";
import Borders from "../../components/Borders";

// SOUND //
import useSound from "../../hooks/useSound";
import snarl01 from "../../assets/sfx/snarl_01.mp3";
import snarl02 from "../../assets/sfx/snarl_02.mp3";

// IMAGES //
import borderPage from "../../assets/border_page.png";

// STYLES //
import "./fight.css"

// IMAGES //
import background from "../../assets/confrontation_bg.png";
import drawing from "../../assets/confrontation_drawing.png";
import clothing from "../../assets/confrontation_clothing.png";
import complexion from "../../assets/confrontation_complexion.png";
import eyes from "../../assets/confrontation_eye.png";
import hair from "../../assets/confrontation_hair.png";

const confrontationLayers = {
    background,
    clothing,
    complexion,
    eyes,
    hair,
    drawing
};


export default function Fight({ zombie, setZombie, stopMusic }) {

    const { playRandom, stopSound } = useSound();
    
    useEffect(() => {
        playRandom(
            [
                snarl01,
                snarl02
            ],
            1
        );

        return stopSound;
    }, []);

    return (
        <div className="game-page fight-page">
            <Borders image={borderPage} scale={0.98} />

            <h1 className="game-title">LA PIÙ GRAVE DELLE SCELTE</h1>

            <div className="game-main-grid fight-main">
                <div className="game-image-wrapper">
                    {/* <img
                        className="game-image fight-image"
                        src={ defend }
                        alt="Drawing of scary but cute zombie giving chase"
                    /> */}
                    <LayeredPixiImage
                        layers={confrontationLayers}
                        zombie={zombie}
                        layerOptions={{
                            complexion: { alpha: 0.60 }
                        }}
                    />
                </div>

                <section className="game-copy fight-copy">
                    <p>Poor {zombie.name}. Once, those little feet followed you because they loved you. Now they follow for altogether different reasons. Through tears, you look into their remaining {zombie.eye_color} eye and raise your weapon.</p>

                    <div className="page-actions">
                        <Weapon zombie={zombie} setZombie={setZombie} stopSound={stopSound} />

                        <WakeButton
                            zombie={zombie}
                            setZombie={setZombie}
                            stopMusic={stopMusic}
                            stopSound={stopSound}
                        />
                    </div>
                </section>
            </div>
        </div>
    );
}
